import React from 'react';
import Navbar from "./Navbar";
import Footer from "./Footer";

const Terms = () => {
    return (
        <>
            <Navbar />
            <div className="min-h-screen bg-white py-24">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h1 className="text-4xl font-extrabold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent mb-8">
                        Terms of Service
                    </h1>

                    <div className="prose prose-blue max-w-none">
                        <p className="text-lg text-gray-600 mb-6">
                            Last updated: March 20, 2024
                        </p>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
                            <p className="text-gray-600">
                                By accessing and using RemoveBackground.online, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Service Description</h2>
                            <p className="text-gray-600">
                                RemoveBackground.online provides an AI-powered background removal service for images. The service processes images locally in your browser and does not upload them to any servers.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. User Obligations</h2>
                            <p className="text-gray-600">
                                You agree to:
                            </p>
                            <ul className="list-disc pl-6 mt-4 text-gray-600">
                                <li>Use the service in compliance with all applicable laws</li>
                                <li>Not attempt to interfere with the proper functioning of the service</li>
                                <li>Not use the service for any illegal or unauthorized purpose</li>
                                <li>Not infringe upon the intellectual property rights of others</li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Intellectual Property</h2>
                            <p className="text-gray-600">
                                The service, including all related software, algorithms, and design elements, is protected by intellectual property laws. You may not copy, modify, distribute, sell, or lease any part of our service.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Limitation of Liability</h2>
                            <p className="text-gray-600">
                                The service is provided "as is" without any warranties. We are not liable for any damages arising from your use of the service or any inability to use the service.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Changes to Terms</h2>
                            <p className="text-gray-600">
                                We reserve the right to modify these terms at any time. We will notify users of any material changes by posting the new terms on this page.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Us</h2>
                            <p className="text-gray-600">
                                If you have any questions about these Terms of Service, please contact us at:{' '}
                                <a href="mailto:legal@removebackground.online" className="text-blue-600 hover:text-blue-500">
                                    legal@removebackground.online
                                </a>
                            </p>
                        </section>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Terms;